import React from "react";

import clsx from "clsx";

import { GenericTooltip } from "@components/tooltip-container";
import { usePrettyLogEventPage } from "@components/v2/analytics";
import { useChartState } from "@features/sales-v3/hooks/use-chart-state";
import { IconButton } from "@shared/buttons";

interface SelectChartTypesProps {
  chartIndex: number;
  disabled?: boolean;
}

export const ChartTypesButtons = ({
  chartIndex,
  disabled = false,
}: SelectChartTypesProps) => {
  const prettyLogEventPage = usePrettyLogEventPage();
  const { getChartAt, updateChartType } = useChartState();
  const { chartType } = getChartAt(chartIndex);

  const setLineChartType = () => {
    if (chartType === "line") {
      return;
    }

    updateChartType(chartIndex, "line");
  };

  const setBarChartType = () => {
    if (chartType === "bar") {
      return;
    }

    updateChartType(chartIndex, "bar");
  };

  return (
    <div
      className={clsx("flex flex-col justify-between", {
        "opacity-60	pointer-events-none": disabled,
      })}
    >
      <div className="font-bold text-xs mb-0.5">CHART TYPE</div>
      <div className="flex space-x-2">
        <GenericTooltip content="Line" noInfoCircle mouseEnterDelay={0.1}>
          <IconButton
            className={clsx("border rounded-lg p-0 w-[34px] h-[34px]", {
              "bg-cosmic text-white border-transparent": chartType === "line",
              "hover:bg-cosmic-4 hover:border-cosmic+1": chartType !== "line",
            })}
            disabled={disabled}
            onClick={() => {
              prettyLogEventPage({
                domain: "Charts",
                action: "onClick",
                additionalActionInfo: "Change Chart Type line",
              });

              setLineChartType();
            }}
          >
            <i className="fa-regular fa-sharp fa-line-chart" />
          </IconButton>
        </GenericTooltip>
        <GenericTooltip content="Bar" noInfoCircle mouseEnterDelay={0.1}>
          <IconButton
            className={clsx("border rounded-lg p-0 w-[34px] h-[34px]", {
              "bg-cosmic text-white border-transparent": chartType === "bar",
              "hover:bg-cosmic-4 hover:border-cosmic+1":
                !disabled && chartType !== "bar",
              "opacity-60	": disabled,
            })}
            disabled={disabled}
            onClick={() => {
              prettyLogEventPage({
                domain: "Charts",
                action: "onClick",
                additionalActionInfo: "Change Chart Type bar",
              });

              setBarChartType();
            }}
          >
            <i className="fa-regular fa-sharp fa-chart-simple" />
          </IconButton>
        </GenericTooltip>
      </div>
    </div>
  );
};
